import FirebaseContext from './context';
import AuthContext from './authContext';
import Firebase from './firebase';

export default Firebase;

export { FirebaseContext, AuthContext };
